import React, { useState, useEffect,useRef, useCallback } from "react";
import Modal from "components/global/modal";
import ReactPlayer from "react-player";
import "./styles.css";
import { FaTimes } from "react-icons/fa";
import { TikTokEmbed, FacebookEmbed, InstagramEmbed, LinkedInEmbed, TwitterEmbed, PinterestEmbed} from 'react-social-media-embed';


export default function WatchMediaModal({ hide, ...props }) {
  const { title, url, tiktok, header="Watch",orientation="Landscape" } = props;
  const [play, setPlay] = useState(true);
  const [progressTime,setProgressTime] = useState();
  const [isMobile, setIsMobile] = React.useState(false);

  const getEmbedUrl = (url) => {
    if (url.includes("dailymotion.com/")) {
      const videoId = url.split("/video/")[1];
      return `https://www.dailymotion.com/embed/video/${videoId}`;
    }
    else if (url.includes("linkedin.com/")) {
      const postId = url.split("activity-")[1].split("-")[0];
      return `https://www.linkedin.com/embed/feed/update/urn:li:activity:${postId}?compact=true`;
    }
    else if (url.includes("imdb.com/video/")) {
      const videoId = url.split('/video/')[1].split('/')[0];
      return `https://www.imdb.com/videoembed/${videoId}`;
    }
    else if (url.includes("brighteon.com/")) {
      const videoId = url.split("/")[3];
      return `https://www.brighteon.com/embed/${videoId}`;
    }
    else if (url.includes("bitchute.com/")) {
      const videoId = url.split("/video/")[1];
      return `https://www.bitchute.com/embed/${videoId}`;
    }
    else if (url.includes("rumble.com/")) {
      const videoId = url.split("/")[4];
      return `https://rumble.com/embed/${videoId}/`;
    }
    else if (url.includes("archive.org/")) {
      const videoId = url.split("/details/")[1];
      return `https://archive.org/embed/${videoId}`;
    }
    else if (url.includes("dropbox.com/")) {
      const videoId = url.split("id=")[1];
      return `https://www.dropbox.com/embed/${videoId}`;
    }
    else if (url.includes("odysee.com/")) {
      const videoId = url.split("/")[4];
      return `https://odysee.com/$/embed/${videoId}`;
    }
    return url;
  };

  React.useEffect(()=>{
    const userAgent = window.navigator.userAgent;
    const mobileDevices = /Mobi|Android|iPhone|Ipad/;
    setIsMobile(mobileDevices.test(userAgent));
  },[])

  return (
    <Modal
      width={`w-full lg:w-16/20 2sm:w-16/20 ${isMobile && 'h-screen flex'} ${(url.includes("tiktok.com/") && isMobile) ? '' : 'items-center'}`}
      contentClassName="rounded-lg overflow-auto custom-style"
      wrapperClassName={`overflow-visible custom-style shadow-none`}
      image_gallery={true}
      isVideo={true}
    >
      <div className={`w-full`}>
        <div className={`flex justify-between items-center ${isMobile && 'bg-black px-3'}`}>
          <p className="text-xl text-white">
            <span className="font-bold mr-1">{header}</span>
            {title}
          </p>
          {/* close */}
          <button onClick={() => hide({progressTime})}>
            <FaTimes className="text-white text-xl" />
          </button>
        </div>

        {url.includes("tiktok.com/") ? (
          <div className="flex justify-center">
            {/* <TikTokEmbed url={url} /> */}
            <TikTokEmbedVid videoId="6718335390845095173" url={url} isMobile={isMobile}/>
          </div>
        ) : url.includes("facebook.com/") ? (
          <div className="flex justify-center">
            {/* <FacebookEmbed url={url} width={550} /> */}
            <FacebookVideoEmbed videoUrl={url} orientation={orientation}/>
          </div>
        ) : url.includes("instagram.com/") ? (
          <div className="flex justify-center">
            {/* <InstagramEmbed url={url} /> */}
            <InstagramVideoEmbed url={url}/>
          </div>
        ) : url.includes("pinterest.com/") ? (
          <div className="flex justify-center">
            <PinterestEmbed url={url} />
          </div>
        ) : url.includes("twitter.com/") ? (
          <div className="flex justify-center">
            <TwitterEmbed url={url} />
          </div>
        )
        : url.includes("x.com/") ? (
          <div className="flex justify-center bg-black">
            <TwitterVidEmbed url={url} orientation={orientation}/>
          </div>
        ): url.includes('youtube.com') || url.includes('youtu.be') ?
        (
          <YoutubeEmbed 
            url={url} 
            setPlay={setPlay}
            setProgressTime={setProgressTime}
            play={play}
          />
        )
         : ReactPlayer.canPlay(url) &&  !url.includes("dailymotion.com/")? (
          <div className={`video-wrapper bg-black`}> {/** ${isMobile && 'mobile'}*/}
            <ReactPlayer
              className="player"
              url={url}
              controls={true}
              playing={play}
              width="100%"
              height="100%"
              onPlay={() => setPlay(true)}
              onPause={() => setPlay(false)}
              onProgress={(progress)=>setProgressTime(progress)}
            />
          </div>
        ) 
        : (
            <div style={{ left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '56.25%' }}>
              <iframe 
                src={getEmbedUrl(url)} 
                style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }} 
                allowFullScreen 
                scrolling="no" 
                title="iframe"
                allow="encrypted-media">
              </iframe>
            </div> 
          )
          }
      </div>
    </Modal>
  );
}


const FacebookVideoEmbed = ({ videoUrl, orientation = "Landscape" }) => {
  const [style, setStyle] = useState({
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    border: 0,
  });

  // --- your existing working logic for Landscape/Portrait, untouched ---
  useEffect(() => {
    if (orientation === "Square") return; // handled separately below

    console.log(orientation);
    if (videoUrl.includes('reel') && orientation === "Landscape") {
      setStyle({
        top: "5px", width: '80vw', height: '100%', position: 'absolute', border: 0
      });
      return;
    }
    else if (videoUrl.includes('reel')) {
      setStyle({
        top: 0, left: '36%', width: '26vw', height: '100%', position: 'absolute', border: 0
      });
      return;
    }
    if (orientation === "Portrait") {
      setStyle({
        top: 0, left: '36%', width: '26vw', height: '100%', position: 'absolute', border: 0
      });
    } else if (orientation === "Landscape") {
      setStyle({ ...style, width: "80vw", height: "45vw" });
    }
  }, [videoUrl, orientation]);

  // --- NEW: Twitter-style live measurement, only for Square ---
  const [squareBoxHeight, setSquareBoxHeight] = useState(null);
  const squareContainerRef = useRef(null);

  useEffect(() => {
    if (orientation !== "Square") return;

    // load FB SDK once
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0';
      script.async = true;
      document.body.appendChild(script);
    }

    let cancelled = false;
    let observer;

    const handleResize = (id, width, height) => {
      // setSquareBoxHeight('45vw')
      if (!cancelled && height) setSquareBoxHeight(height);
    };

    const findAndMeasure = () => {
      if (cancelled) return;
      if (!window.FB?.XFBML) {
        setTimeout(findAndMeasure, 200);
        return;
      }
      window.FB.Event.subscribe('xfbml.resize', handleResize);
      window.FB.XFBML.parse(squareContainerRef.current);

      // fallback: also directly observe the injected iframe
      const tryObserveIframe = () => {
        if (cancelled) return;
        const iframe = squareContainerRef.current?.querySelector("iframe");
        if (!iframe) {
          setTimeout(tryObserveIframe, 200);
          return;
        }
        const measure = () => iframe.offsetHeight && setSquareBoxHeight(iframe.offsetHeight);
        measure();
        if (window.ResizeObserver) {
          observer = new ResizeObserver(measure);
          observer.observe(iframe);
        }
      };
      tryObserveIframe();
    };

    findAndMeasure();

    return () => {
      cancelled = true;
      observer?.disconnect();
      window.FB?.Event?.unsubscribe('xfbml.resize', handleResize);
    };
  }, [videoUrl, orientation]);

  if (orientation === "Square") {
    // alert(squareBoxHeight)
    if(squareBoxHeight > 800) setSquareBoxHeight(800);
    if(squareBoxHeight < 350) setSquareBoxHeight(800);

    return (
      <div
        className="bg-black flex items-center justify-center"
        style={{
          width: '100%',
          overflow: "hidden",
          height: squareBoxHeight ? squareBoxHeight : 800, // fallback while measuring
          minHeight: 800,
          transition: "height 0.15s ease",
        }}
      >
        <div ref={squareContainerRef} style={{ width: "min(100%, 800px)", margin: "0 auto" }}>
          <div
            className="fb-video"
            data-href={videoUrl}
            data-show-text="false"
            data-width="800"
          />
        </div>
      </div>
    );
  }

  // Landscape / Portrait — your original, unchanged
  return (
    <div className="facebook-video-container flex items-center justify-center bg-black" style={{ left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '57.25%' }}>
      <iframe
        src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(videoUrl)}&show_text=0`}
        style={{ ...style }}
        allow="autoplay; encrypted-media;"
        allowFullScreen
        title="facebook-videos"
      ></iframe>
    </div>
  );
};

const TikTokEmbedVid = ({ videoId = '6718335390845095173', url,isMobile }) => {
  const getTikTokVideoId = (url) => {
    try {
      const parsedUrl = new URL(url);
      const pathSegments = parsedUrl.pathname.split("/");
      let vidID = pathSegments[pathSegments.length - 1] || videoId;
      console.log(vidID)
      return `https://www.tiktok.com/player/v1/${vidID}?autoplay=1`;
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };
  return (
    <div style={{ left: 0, width: '100%', height:`${isMobile ? '90vh' : 0}` , position: 'relative', paddingBottom: '56.25%' }}>
      <iframe
        src={getTikTokVideoId(url)}
        style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }} 
        allowFullScreen
        title="TikTok Video"
        frameBorder="0"
      ></iframe>
    </div>
  );
};

const InstagramVideoEmbed = (url,isMobile) => {
  console.log(url)
  const [urlEmbed,setUrl] = useState();

  const extractReelsId = useCallback((url) => {
    const reelMatch = url.match(/\/reel\/([^/]+)/);
    const postMatch = url.match(/\/p\/([^/]+)/);
    if (reelMatch) return { type: 'reel', id: reelMatch[1] };
    if (postMatch) return { type: 'p', id: postMatch[1] };
    return null;
  },[]);
  
  useEffect(()=>{
    let reelID = extractReelsId(url.url);
      const embedUrl = `https://www.instagram.com/${reelID.type}/${reelID.id}/embed`;
    setUrl(embedUrl);
  },[url ,extractReelsId,setUrl])
  return (
    <div className="instagram-embed-container bg-black" style={{left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '57.25%' }}>
      <iframe
        src={urlEmbed}
        style={{ top: 0, left: '36%', width: '26vw', height: '100%', position: 'absolute', border: 0 }} 
        frameBorder="0"
        allowFullScreen
        title="instagram"
      ></iframe>
    </div>
  );
};

const TwitterVidEmbed = (url, orientation = "Landscape") => {

  const [style, setStyle] = useState({
      max_width: 1260,
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      alignItems:'center',
      margin:0
  });

  const [embedUrl, setEmbedUrl] = useState(null);
  const [boxHeight, setBoxHeight] = useState(null); // null = still loading
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (url?.url) {
      console.log(url);
      const linkSource = `${url.url.replace('x', 'twitter')}?ref_src=twsrc%5Etfw`;
      console.log(linkSource);
      setEmbedUrl(linkSource);
      const maxWidth = url?.orientation === 'Landscape' ? 1260 : 780;
      setStyle({
        ...style,
        max_width: maxWidth,
        // marginTop: url?.orientation === 'Landscape' ? "2rem" : 0,
      })
    }
  }, [url])

  // measure the real rendered iframe once Twitter injects it
  useEffect(() => {
    if (!embedUrl || !containerRef.current) return;
    let cancelled = false;
    let observer;

    const findAndMeasure = () => {
      if (!window.twttr?.widgets) {
        if (!cancelled) setTimeout(findAndMeasure, 200);
        return;
      }
      window.twttr.widgets.load(containerRef.current).then(() => {
        if (cancelled) return;
        const iframe = containerRef.current.querySelector("iframe");
        if (!iframe) {
          setTimeout(findAndMeasure, 200);
          return;
        }

        const measure = () => {
          const h = iframe.offsetHeight;
          if (h) setBoxHeight(h);
        };

        measure();
        if (window.ResizeObserver) {
          observer = new ResizeObserver(measure);
          observer.observe(iframe);
        }
      });
    };

    findAndMeasure();
    return () => {
      cancelled = true;
      observer?.disconnect();
    };
  }, [embedUrl]);

  return (
    <div
      className="bg-black"
      style={{
        width: '100%',
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // fallback height while Twitter's iframe hasn't loaded/measured yet
        height: boxHeight ? boxHeight : 780,
        minHeight: 780,
        transition: "height 0.15s ease",
        // marginBottom: '10px'
      }}
    >
      { embedUrl &&
        (<div ref={containerRef} style={{
            ...style,
            width: `min(100%, ${style.max_width}px)`,
            margin: "0 auto",
          }}>
          <blockquote className="twitter-tweet"
            data-media-max-width={style.max_width}
            style={{ border: 'none', margin: "0 auto", width: "100%", alignItems:'center' }}
          >
            <p lang="en" dir="ltr">
            </p><a href={embedUrl}>
            </a>
          </blockquote>
        </div>)
      }
    </div>
  );
};

const YoutubeEmbed = ({url,play,setPlay,setProgressTime})=>{ 
  const [playlist_id,setPlaylistYT] = useState(null);
  const [ytURL,setYTurl] = useState(null);
  const [playlistPge,setPlayListPage] = useState(false);

  useEffect (()=>{
    if(url.includes('youtube.com') || url.includes('youtu.be')){
        const urlObj = new URL(url); 
        const list = urlObj.searchParams.get("list");
        if(list && url.includes('watch')){
          const playlist_ID = list.split("&")[0];
          const cleanList = url.split("&")[0] || url;
          setPlaylistYT(playlist_ID);
          setYTurl(cleanList)
          setPlayListPage(false)
        }else if(list && url.includes('playlist')){
          const playlist_ID = list.split("&")[0];
          setPlaylistYT(null);
          setYTurl(`https://www.youtube.com/embed?listType=playlist&list=${playlist_ID}`)
          setPlayListPage(true)
        }
        else{
          setYTurl(url);
          setPlaylistYT(null)
        }
    }
  },[url])
  
  return(
    <>
      { playlistPge && playlist_id === null ? /**use the frame if the link url is from playlist page */
        <div className="instagram-embed-container bg-black" style={{left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '57.25%' }}>
          <iframe
            src={ytURL}
            style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }} 
            frameBorder="0"
            allowFullScreen
            title="instagram"
          ></iframe>
        </div>:
        // use player for normal yt and playlist with watch params
        <div className={`video-wrapper bg-black`}> {/** ${isMobile && 'mobile'}*/}
          <ReactPlayer
            className="player"
            url={ytURL}
            controls={true}
            playing={play}
            width="100%"
            height="100%"
            onPlay={() => setPlay(true)}
            onPause={() => setPlay(false)}
            onProgress={(progress)=>setProgressTime(progress)}
            config={{ youtube: { 
              playerVars: { 
                listType:'playlist',
                list:playlist_id
              }
            }}}
          />
        </div>
      }
    </>
    
    
  )
}





